export const PROVISION_STATUS_KEY_BASE = 'provision-status';
export const ProvisionStatusKeyFactory = {
    provisionStatus: (workspaceId) => [
        PROVISION_STATUS_KEY_BASE,
        workspaceId,
    ],
};
